module.exports = __webpack_public_path__ + "img/SMARTFORM.696ae0b5.png";